var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"general__img__wrapper"},[(_vm.link)?_c('a',{attrs:{"href":_vm.link}},[_c('img',{attrs:{"src":_vm.image_src}})]):_c('img',{directives:[{name:"img",rawName:"v-img"}],attrs:{"src":_vm.image_src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }